exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "fieldset {\r\n    margin-bottom: 20px !important;\r\n}\r\n\r\n    fieldset legend {\r\n        padding-bottom: 5px !important;\r\n        font-size: 15px !important;\r\n    }\r\n\r\n.checkbox {\r\n    padding-right: 10px !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/gas-two/gastwo-addupdate/gastwo-add-update.component.css
// module id = 687
// module chunks = 0